import {ValueObject} from '@s-ui/domain'

import {QueryStringSharedValueObject} from './QueryStringSharedValueObject.js'
import {StringSharedValueObject} from './StringSharedValueObject.js'

const QUERY_PREFIX = '?'

export class UrlSharedValueObject extends ValueObject {
  #path
  #query

  constructor({path, query}) {
    super()
    this.#path = path
    this.#query = query
  }

  static createWithSanitize({config, url}) {
    const [path, query] = url.split(QUERY_PREFIX)

    return new UrlSharedValueObject({
      path: StringSharedValueObject.create({value: path}),
      query: QueryStringSharedValueObject.createWithSanitize({config, queryString: query})
    })
  }

  get query() {
    return this.#query.value
  }

  get path() {
    return this.#path.value
  }

  get url() {
    return `${this.#path.value}${this.#query.queryString}`
  }

  get value() {
    return {path: this.#path.value, query: this.#query.value}
  }
}
